import { db } from '../config/firebase';
import { collection, getDocs, addDoc, query, orderBy } from 'firebase/firestore';

const COLLECTION_NAME = 'teamNames';

export const teamNameService = {
  // チーム名一覧を取得
  getAllTeamNames: async () => {
    try {
      const q = query(collection(db, COLLECTION_NAME), orderBy('name'));
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (error) {
      console.error('チーム名一覧の取得に失敗:', error);
      throw error;
    }
  },

  // 新しいチーム名を追加
  createTeamName: async (teamName) => {
    try {
      const docRef = await addDoc(collection(db, COLLECTION_NAME), {
        name: teamName,
        createdAt: new Date()
      });
      return docRef.id;
    } catch (error) {
      console.error('チーム名の作成に失敗:', error);
      throw error;
    }
  }
};
